import React, { useContext, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Switch from "react-switch";
import moment from "moment";

import AdminLayout from "../../components/Admin/AdminLayout";
import AdminPageShell from "../../components/Admin/AdminPageShell";
import { adminTableStyles } from "../../components/Admin/adminTableStyles";
import { api } from "../../api/api";
import AuthContext from "../../contexts/AuthCtx";
import { toast } from "../../utils/toast";

function AllUsers() {
  const [users, setUsers] = useState([]);
  const [updatingId, setUpdatingId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const AuthCtx = useContext(AuthContext);

  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.get("admin/getUsers", {
        headers: { Authorization: `Bearer ${AuthCtx.userToken}` },
      });
      setUsers(data.users || []);
    } catch (err) {
      toast.error("Impossible de charger les utilisateurs.");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AuthCtx.userToken]);

  const switchChangeHandler = async (isActive, id) => {
    const previous = users;
    setUsers((list) =>
      list.map((user) => (user._id === id ? { ...user, isActive } : user))
    );
    setUpdatingId(id);

    try {
      await api.put(
        `admin/changeStatus/${id}`,
        { isActive },
        { headers: { Authorization: `Bearer ${AuthCtx.userToken}` } }
      );
      toast.success("Statut mis à jour.");
    } catch (err) {
      setUsers(previous);
      toast.error("Erreur lors de la mise à jour.");
      console.error(err);
    } finally {
      setUpdatingId(null);
    }
  };

  const columns = [
    {
      name: "Email",
      selector: (row) => row.email,
      grow: 2,
    },
    {
      name: "Lettres",
      selector: (row) => row.letters,
      width: "100px",
    },
    {
      name: "Actif",
      cell: (row) => (
        <Switch
          onChange={(value) => switchChangeHandler(value, row._id)}
          checked={Boolean(row.isActive)}
          disabled={updatingId === row._id}
          onColor="#849C8D"
          offColor="#D1D5DB"
          height={22}
          width={44}
          handleDiameter={18}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "100px",
    },
    {
      name: "Inscrit le",
      selector: (row) => moment(row.createdAt).format("DD/MM/YYYY"),
      width: "130px",
    },
  ];

  return (
    <AdminLayout>
      <AdminPageShell
        title="Utilisateurs"
        subtitle="Gère les comptes et active ou désactive l'accès au service."
        isLoading={isLoading}
      >
        <DataTable
          columns={columns}
          data={users}
          noHeader
          highlightOnHover
          pagination
          responsive
          customStyles={adminTableStyles}
          noDataComponent={
            <div className="py-12 text-center font-josefin text-sm text-textMuted">
              Aucun utilisateur.
            </div>
          }
        />
      </AdminPageShell>
    </AdminLayout>
  );
}

export default AllUsers;
